import state from "@/store/modules/entrance-exit-preview/state";
import actions from "@/store/modules/entrance-exit-preview/actions";
import mutations from "@/store/modules/entrance-exit-preview/mutations";
import getters from "@/store/modules/entrance-exit-preview/getters";

export default {
  state,
  actions,
  mutations,
  getters
}